import React from "react";
import PhoneInput from "../ui/PhoneInput";
import Input from "../ui/Input";

const SecondForm = ({
  firstName,
  lastName,
  countryCode,
  phoneNumber,
  checkIn,
  checkInTime,
  checkOut,
  checkOutTime,
  onFirstNameChange,
  onLastNameChange,
  onPhoneNumberChange,
  onCountryCodeChange,
  onCheckInChange,
  onCheckInTimeChange,
  onCheckOutChange,
  onCheckOutTimeChange,
  handleNext,
  step,
}) => {
  return (
    <>
      <PhoneInput
        disabled={false}
        countryCodes={["+1", "+91"]}
        countryCode={countryCode}
        phoneNumber={phoneNumber}
        onPhoneNumberChange={onPhoneNumberChange}
        onCountryCodeChange={onCountryCodeChange}
      />
      <Input
        name="First name"
        type="text"
        value={firstName}
        onChange={(e) => onFirstNameChange(e)}
      />
      <Input
        name="Last name"
        type="text"
        value={lastName}
        onChange={(e) => onLastNameChange(e)}
      />
      <div>
        <div className="text-sm">Details</div>
        <div className="flex flex-col gap-3">
          <div className="border border-neutral-300 rounded-md">
            <div className="text-sm bg-white p-2 rounded-t-md border-b border-b-1 ">
              Check In
            </div>
            <div className="flex">
              <input
                type="date"
                className="block w-full rounded-bl-md bg-white px-3 py-1.5 text-sm text-gray-900  outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                value={checkIn}
                required
                onChange={(e) => onCheckInChange(e)}
              />
              <input
                type="time"
                className="block w-full rounded-br-md text-sm bg-white px-3 py-1.5  text-gray-900  outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                style={{ textAlign: "right" }}
                value={checkInTime}
                required
                onChange={(e) => onCheckInTimeChange(e)}
              />
            </div>
          </div>
          <div className="border border-neutral-300 rounded-md">
            <div className="text-sm bg-white p-2 rounded-t-md border-b border-b-1 ">
              Check Out
            </div>
            <div className="flex">
              <input
                type="date"
                className="block w-full rounded-bl-md bg-white px-3 py-1.5 text-sm text-gray-900  outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                value={checkOut}
                min={checkIn}
                required
                onChange={(e) => onCheckOutChange(e)}
              />
              <input
                type="time"
                className="block w-full rounded-br-md text-sm bg-white px-3 py-1.5  text-gray-900  outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                style={{ textAlign: "right" }}
                {...(checkOut === checkIn && { min: checkInTime })}
                value={checkOutTime}
                required
                onChange={(e) => onCheckOutTimeChange(e)}
              />
            </div>
          </div>
          {/**step == 2 && (
          <div className="flex justify-end mt-3">
            <button
              type="button"
              onClick={handleNext}
              className="w-full px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Next
            </button>
          </div> 
        )*/}
        </div>
      </div>
    </>
  );
};
export default SecondForm;
